import React from "react";
import { Container } from "../../../../components/Grid/Grid";
import Tabs from "../../../../components/__common/_controls/Tab/Tab";
import { TabItem } from "../../../../utils/privacyPolicyUtils";

interface PrivacyPolicyTabsProps {
  shouldShowTabs: boolean;
  tabItem: TabItem[];
  activeTab: string;
  onTabChange: (tabName: string) => void;
}

/**
 * PrivacyPolicyTabs component
 * Displays tabs for switching between Global and Local privacy policy (EU countries only)
 */
export const PrivacyPolicyTabs: React.FC<PrivacyPolicyTabsProps> = ({
  shouldShowTabs,
  tabItem,
  activeTab,
  onTabChange,
}) => {
  if (!shouldShowTabs) {
    return null;
  }

  return (
    <Container>
      <Tabs className="tabs">
        {tabItem.map((tab) => (
          <Tabs.Tab
            key={tab.name}
            radioTestId="request-type-input"
            id={tab.name}
            title={tab.name}
            name={tab.name}
            checked={activeTab === tab.name}
            onChange={() => onTabChange(tab.name)}
          />
        ))}
      </Tabs>
    </Container>
  );
};
